import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { NombreIcono, VIEW_BOX } from './glifos';

export type { NombreIcono } from './glifos';

/**
 * Icono del portal (FP-03).
 *
 *     <svg app-icono nombre="whatsapp"></svg>
 *
 * Los glifos salen de `public/icons/` — los mismos SVG que exporta Figma y usa
 * el backoffice — y se inlinean en `icono.html`, que genera
 * `npm run iconos`. Para sumar uno: copiar el .svg a `public/icons/`,
 * agregarlo a `EN_USO` en `scripts/generar-iconos.mjs` y regenerar.
 *
 * El selector aplica sobre un `<svg>` para que el tamaño se controle desde el
 * CSS del componente que lo usa (`.boton svg { width: 24px }`).
 *
 * El color se hereda con `currentColor`: se pinta con `color` en el contenedor.
 *
 * Los iconos son decorativos (`aria-hidden`): el texto accesible lo pone el
 * botón o el link que los contiene.
 */
@Component({
  selector: 'svg[app-icono]',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.viewBox]': 'viewBox()',
    fill: 'none',
    'aria-hidden': 'true',
    focusable: 'false',
  },
  templateUrl: './icono.html',
})
export class Icono {
  readonly nombre = input.required<NombreIcono>();

  protected readonly viewBox = computed(() => VIEW_BOX[this.nombre()]);
}
